/* Évoque: smooth scrolling, reveal-on-scroll, parallax and scroll-reactive marquees. */
(function () {
  'use strict';
  var html = document.documentElement;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motion = !design && !reduce;
  if (motion) html.classList.add('evq-motion');

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var main = document.getElementById('MainContent') || document.querySelector('main');

    /* Hide the drop product grid until the collection has products */
    if (!design) {
      document.querySelectorAll('[id$="__products_drop"]').forEach(function (s) {
        if (!s.querySelector('a[href*="/products/"]')) s.style.display = 'none';
      });
    }

    /* ---------- Smooth scrolling ---------- */
    var lenis = null;
    var finePointer = window.matchMedia('(pointer: fine)').matches;
    if (motion && finePointer && typeof window.Lenis === 'function') {
      lenis = new window.Lenis({
        duration: 1.15,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        smoothWheel: true,
        wheelMultiplier: 0.95,
        prevent: function (node) {
          if (!(node instanceof Element) || node === html || node === document.body) return false;
          if (node.nodeName === 'DIALOG' || node.hasAttribute('data-lenis-prevent')) return true;
          return node.scrollHeight > node.clientHeight + 2 && /(auto|scroll)/.test(getComputedStyle(node).overflowY);
        }
      });
      window.evoqueLenis = lenis;

      var locked = false;
      var syncLock = function () {
        var modal = false;
        try { modal = !!document.querySelector('dialog:modal'); } catch (e) { modal = !!document.querySelector('dialog[open]'); }
        var hidden = getComputedStyle(html).overflowY === 'hidden' || getComputedStyle(document.body).overflowY === 'hidden';
        var shouldLock = modal || hidden;
        if (shouldLock !== locked) { locked = shouldLock; if (locked) lenis.stop(); else lenis.start(); }
      };
      var mo = new MutationObserver(syncLock);
      mo.observe(html, { attributes: true, attributeFilter: ['class', 'style'] });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      document.addEventListener('toggle', syncLock, true);
      document.addEventListener('close', syncLock, true);

      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a) return;
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var el = null;
        try { el = document.querySelector(id); } catch (err) { return; }
        if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -90 }); }
      });
    }

    /* ---------- Marquees speed up while scrolling ---------- */
    var marqueeAnims = [];
    var collectMarquees = function () {
      marqueeAnims = [];
      document.querySelectorAll('marquee-component').forEach(function (m) {
        if (m.getAnimations) marqueeAnims = marqueeAnims.concat(m.getAnimations({ subtree: true }));
      });
    };
    var rate = 1;

    /* ---------- Parallax on the big editorial pictures ---------- */
    var parallax = [];
    if (motion) {
      document.querySelectorAll('[id$="__banner_trio"] img, [id$="__story"] img').forEach(function (img) {
        if (img.parentElement) img.parentElement.style.overflow = 'hidden';
        img.style.willChange = 'transform';
        parallax.push(img);
      });
    }
    var updateParallax = function () {
      var vh = window.innerHeight;
      parallax.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
        img.style.transform = 'translate3d(0,' + (-p * 50).toFixed(1) + 'px,0) scale(1.09)';
      });
    };

    var lastY = window.scrollY, lastT = performance.now();
    var loop = function (t) {
      if (lenis) lenis.raf(t);
      var y = window.scrollY;
      var dt = Math.max(16, t - lastT);
      var velocity = lenis ? lenis.velocity : (y - lastY) / dt * 16;
      lastY = y; lastT = t;
      if (motion && marqueeAnims.length) {
        var target = 1 + Math.min(Math.abs(velocity) / 7, 3.5);
        rate += (target - rate) * 0.12;
        if (Math.abs(rate - 1) < 0.005) rate = 1;
        marqueeAnims.forEach(function (a) { if (a.playbackRate !== rate) a.playbackRate = rate; });
      }
      if (parallax.length) updateParallax();
      requestAnimationFrame(loop);
    };
    if (motion) {
      collectMarquees();
      setTimeout(collectMarquees, 1200);
      requestAnimationFrame(loop);
    }

    /* ---------- Reveal on scroll ---------- */
    if (motion && main && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      var add = function (el, delay) {
        if (!el || el.classList.contains('evq-reveal')) return;
        el.classList.add('evq-reveal');
        if (delay) el.style.setProperty('--evq-delay', delay + 's');
        io.observe(el);
      };

      var sections = Array.prototype.slice.call(main.children).filter(function (s) { return s.classList.contains('shopify-section'); });
      sections.forEach(function (s, index) {
        if (/__(hero_desktop|hero_mobile|campaign_band|wordmark)$/.test(s.id)) return;
        var cards = s.querySelectorAll('.resource-list__item, .product-grid__item, [id$="__lookbook"] .section-content-wrapper > *, [id$="__drop_intro"] .section-content-wrapper > *');
        if (cards.length) {
          cards.forEach(function (c, i) { add(c, Math.min(i % 4, 3) * 0.09); });
        } else if (index > 0 && !/__main$/.test(s.id)) {
          add(s, 0);
        }
      });
      var footerTrust = document.querySelectorAll('[id$="__trust_row"] .section-content-wrapper > *');
      footerTrust.forEach(function (c, i) { add(c, i * 0.08); });
    }
  });
})();
